import Api from '@/services/Api'

export default {
  addSolver (params) {
    return Api().post('tpc/admin/stream/solver', params)
  },
  swapSolvers () {
    return Api().post('tpc/admin/stream/swap', {})
  },
  swapTimes () {
    return Api().post('tpc/admin/stream/swaptimes', {})
  },
  addTime (params) {
    return Api().post('tpc/admin/stream/add_time', params)
  },
  deleteTime (params) {
    return Api().post('tpc/admin/stream/delete_time', params)
  },
}
